import { actionTypes } from '../../../controller';
import {
	generalRing,
} from '../../../../lib/sound';

const {
	SELECT_CONVERSATION_TAG_SUCCESS,
	UPDATE_CONVERSATION_STATUS,
	RECEIVE_CONVERSATION_REPLY,
	RESET_CONVERSATION_SILENCE,
} = actionTypes;
const generalRingActionTypes = [
	UPDATE_CONVERSATION_STATUS,
	SELECT_CONVERSATION_TAG_SUCCESS,
	RECEIVE_CONVERSATION_REPLY,
	RESET_CONVERSATION_SILENCE,
];

function generalRingEmitter() {
	return function (store, action) {
		const { type } = action;
		const { isTurnOnSound } = store.getState().sound.toObject();

		if (!generalRingActionTypes.includes(type) || !isTurnOnSound) {
			return;
		}

		generalRing();
	};
}

export default [
	generalRingEmitter,
];
